import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-275bb67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }


import { PropType } from 'vue';

const __default__ = { name: 'ModalContainer' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  header: {
    type: String as PropType<string>,
    default: () => 'Заголовок не определен!!!',
  },
},
  emits: ['close'],
  setup(__props, { emit }) {






return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"max-width":"calc(100vw - 32px)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "modal__header" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.header), 1),
          _createVNode(_component_q_btn, {
            class: "modal__close-btn",
            round: "",
            flat: "",
            icon: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_section, { class: "scroll" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3
      }),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            label: "отмена",
            color: "accent"
          }, null, 512), [
            [_directive_close_popup]
          ]),
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            label: "ок",
            color: "accent"
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})